export function Eyebrow({ children, dark = false, testId }) {
  return (
    <div
      data-testid={testId}
      className={dark ? "eyebrow-white" : "eyebrow"}
    >
      <span className="gold-line" />
      {children}
    </div>
  );
}

export function SectionHeader({
  eyebrow,
  title,
  subtitle,
  center = false,
  light = false,
  testId,
}) {
  return (
    <div
      data-testid={testId}
      className={`${center ? "text-center mx-auto" : ""} max-w-3xl`}
    >
      {eyebrow && (
        <div className={center ? "flex justify-center mb-6" : "mb-6"}>
          <Eyebrow dark={!light}>{eyebrow}</Eyebrow>
        </div>
      )}
      <h2
        className={`font-heading text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight ${
          light ? "text-[#0a0a0a]" : "text-white"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-6 text-base md:text-lg leading-relaxed ${
            light ? "text-[#3f3f46]" : "text-[#a1a1aa]"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
